import { useEffect } from 'react';

import * as serviceWorker from './registerServiceWorker';

interface ServiceWorkerProps {
  onUpdate: () => void;
}

export const ServiceWorker = ({ onUpdate }: ServiceWorkerProps) => {
  useEffect(() => {
    serviceWorker.register({ onUpdate });
    serviceWorker.disableUserSelect();
  }, [onUpdate]);

  return null;
};
